import styled from "styled-components";

export const Page = styled.div``;

export const Footer = styled.footer`
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 16px;
  padding: 32px;
  text-align: center;
  background: #101015;
  color: #fff;
`;